import { citizenshipEntity } from 'shared';

export const emptyPassenger = {
  lastName: '',
  firstName: '',
  gender: '',
  dob: '',
  citizenship: citizenshipEntity.config.KAZAKHSTAN_CODE,
  document: {
    number: '',
    expiresAt: '',
    givenAt: '',
    organization: '',
    series: '',
  },
  iin: '',
  fin: '',
  airlineBonusCard: '',
};
